<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow">
            <div
              class="card-header card-header-primary negative blue-grad w-50 d-flex"
            >
              <router-link
                class="btn btn-outline-primary btn-sm mr-3"
                :to="{ name: 'all-services-cn' }"
                ><i class="fa fa-chevron-left mr-2"></i
                >{{ $t("message.back") }}</router-link
              >
              <h4 class="card-title">
                {{ $t("message.contragent_search.enterprise_risk_scan") }}
              </h4>
            </div>
            <pdf
              v-if="search_complete"
              :user_id="0"
              :doc_additional="{ request: keyword }"
              :document="results"
              :goods="[]"
              :doc_id="0"
              source="enterprise-risk-scan-cn"
            ></pdf>
            <div class="card-body px-0">
              <div class="row">
                <div class="col-md-4"></div>
                <div class="col-md-4">
                  <span
                    :class="['bmd-form-group mb-2 d-block form-label-group']"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="keyword"
                      v-model="keyword"
                      :placeholder="$t('message.find_partner.search_keyword')"
                      autocomplete="off"
                      style="cursor: auto"
                    />
                    <label for="keyword" class="form-label-group-label">{{
                      $t("message.find_partner.search_keyword")
                    }}</label>
                  </span>
                  <button
                    :class="[
                      'btn',
                      'btn-success',
                      'btn-round',
                      'btn-sm',
                      'position-relative',
                    ]"
                    @click="searchEnterpriseRiscScan"
                    id="init_search_china"
                  >
                    {{ $t("message.find_partner.search_button") }}
                  </button>
                </div>
              </div>

              <div
                v-if="!search_complete && loading"
                style="position: relative; height: 100px"
              >
                <div class="loading"></div>
              </div>
              <div
                v-if="search_complete && no_result"
                class="mt-3 text-center pb-3"
              >
                {{
                  $t("message.find_partner.no_results").replace(
                    "[company]",
                    keyword,
                  )
                }}
              </div>
              <div v-if="search_complete && !no_result" class="mt-3">
                <div class="table-responsive">
                  <div
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.enterprise_risk_scan") }}
                  </div>
                  <div class="p-5">
                    <!-- <div class="row">
                                            <div class="col-6"><h5>{{results.Name}}</h5></div>
                                            <div class="col-6 text-right">
                                                {{results.No}}
                                            </div>
                                        </div> -->
                    <!-- <hr> -->
                    <!--Strings Block-->
                    <div class="row">
                      <div class="col-4">
                        <img :src="results.ImageUrl" :alt="results.ImageUrl" />
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_AreaCode")
                        }}:<br /><strong>{{ results.AreaCode }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_RecCap")
                        }}:<br /><strong>{{ results.RecCap }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_EntType")
                        }}:<br /><strong>{{ results.EntType }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_StockType")
                        }}:<br /><strong>{{ results.StockType }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_StockNumber")
                        }}:<br /><strong>{{ results.StockNumber }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_IsOnStock")
                        }}:<br /><strong>{{ results.IsOnStock }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_OrgNo")
                        }}:<br /><strong>{{ results.OrgNo }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_CheckDate")
                        }}:<br /><strong>{{ results.CheckDate }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_TeamEnd")
                        }}:<br /><strong>{{ results.TeamEnd }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_TermStart")
                        }}:<br /><strong>{{ results.TermStart }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_Scope")
                        }}:<br /><strong>{{ results.Scope }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_Address")
                        }}:<br /><strong>{{ results.Address }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_EconKind")
                        }}:<br /><strong>{{ results.EconKind }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_RegistCapi")
                        }}:<br /><strong>{{ results.RegistCapi }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_CreditCode")
                        }}:<br /><strong>{{ results.CreditCode }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_UpdatedDate")
                        }}:<br /><strong>{{ results.UpdatedDate }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_Province")
                        }}:<br /><strong>{{ results.Province }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_Status")
                        }}:<br /><strong>{{ results.Status }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_EndDate")
                        }}:<br /><strong>{{ results.EndDate }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_StartDate")
                        }}:<br /><strong>{{ results.StartDate }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_OperName")
                        }}:<br /><strong>{{ results.OperName }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_OperId")
                        }}:<br /><strong>{{ results.OperId }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_BelongOrg")
                        }}:<br /><strong>{{ results.BelongOrg }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_No")
                        }}:<br /><strong>{{ results.No }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_Name")
                        }}:<br /><strong>{{ results.Name }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_KeyNo")
                        }}:<br /><strong>{{ results.KeyNo }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_IXCode")
                        }}:<br /><strong>{{ results.IXCode }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_PersonScope")
                        }}:<br /><strong>{{ results.PersonScope }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_EnglishName")
                        }}:<br /><strong>{{ results.EnglishName }}</strong>
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_InsuredCount")
                        }}:<br /><strong>{{ results.InsuredCount }}</strong>
                      </div>

                      <div class="col-4 mb-2" v-if="results.Liquidation">
                        {{
                          $t("message.contragent_search.ers_Liquidation")
                        }}:<br /><strong
                          >{{ results.Liquidation.Leader }} -
                          {{ results.Liquidation.Member }}</strong
                        >
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_ContactInfo")
                        }}:<br /><strong
                          ><span v-if="results.ContactInfo.WebSite"
                            >{{ results.ContactInfo.WebSite.Url }}<br /></span
                          >{{ results.ContactInfo.PhoneNumber }}<br />{{
                            results.ContactInfo.Email
                          }}</strong
                        >
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_Industry")
                        }}:<br />
                        <strong
                          >{{
                            $t(
                              "message.contragent_search.ers_ind_IndustryCode",
                            )
                          }}: {{ IndustryList.IndustryCode }}</strong
                        ><br />
                        <strong
                          >{{
                            $t("message.contragent_search.ers_ind_Industry")
                          }}: {{ IndustryList.Industry }}</strong
                        ><br />
                        <strong
                          >{{
                            $t(
                              "message.contragent_search.ers_ind_SubIndustryCode",
                            )
                          }}: {{ IndustryList.SubIndustryCode }}</strong
                        ><br />
                        <strong
                          >{{
                            $t("message.contragent_search.ers_ind_SubIndustry")
                          }}: {{ IndustryList.SubIndustry }}</strong
                        ><br />
                        <strong
                          >{{
                            $t(
                              "message.contragent_search.ers_ind_MiddleCategoryCode",
                            )
                          }}: {{ IndustryList.MiddleCategoryCode }}</strong
                        ><br />
                        <strong
                          >{{
                            $t(
                              "message.contragent_search.ers_ind_MiddleCategory",
                            )
                          }}: {{ IndustryList.MiddleCategory }}</strong
                        ><br />
                        <strong
                          >{{
                            $t(
                              "message.contragent_search.ers_ind_SmallCategoryCode",
                            )
                          }}: {{ IndustryList.SmallCategoryCode }}</strong
                        ><br />
                        <strong
                          >{{
                            $t(
                              "message.contragent_search.ers_ind_SmallCategory",
                            )
                          }}: {{ IndustryList.SmallCategory }}</strong
                        ><br />
                      </div>
                      <div class="col-4 mb-2">
                        {{ $t("message.contragent_search.ers_Area") }}:<br />
                        <strong
                          >{{
                            $t("message.contragent_search.ers_area_Province")
                          }}: {{ AreaList.Province }}</strong
                        ><br />
                        <strong
                          >{{ $t("message.contragent_search.ers_area_City") }}:
                          {{ AreaList.City }}</strong
                        ><br />
                        <strong
                          >{{
                            $t("message.contragent_search.ers_area_County")
                          }}: {{ AreaList.County }}</strong
                        ><br />
                      </div>
                      <div class="col-4 mb-2">
                        {{
                          $t("message.contragent_search.ers_RevokeInfo")
                        }}:<br />
                        <strong
                          >{{
                            $t("message.contragent_search.ers_rev_CancelDate")
                          }}: {{ RevokeInfoList.CancelDate }}</strong
                        ><br />
                        <strong
                          >{{
                            $t(
                              "message.contragent_search.ers_rev_CancelReason",
                            )
                          }}: {{ RevokeInfoList.CancelReason }}</strong
                        ><br />
                        <strong
                          >{{
                            $t("message.contragent_search.ers_rev_RevokeDate")
                          }}: {{ RevokeInfoList.RevokeDate }}</strong
                        ><br />
                        <strong
                          >{{
                            $t(
                              "message.contragent_search.ers_rev_RevokeReason",
                            )
                          }}: {{ RevokeInfoList.RevokeReason }}</strong
                        ><br />
                      </div>
                    </div>
                  </div>

                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.ers_PermissionInfo") }}
                  </h5>
                  <h6>
                    {{ $t("message.contragent_search.ers_PermissionInfo_description") }}
                  </h6>
                  <div class="p-5">
                    <div class="table-responsive">
                      <b-table
                        :fields="PermissionInfo_fields"
                        :items="results.PermissionInfo"
                      ></b-table>
                    </div>
                  </div>
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.ers_Penalty") }}
                  </h5>
                  <div class="p-5">
                    <div class="table-responsive">
                      <b-table
                        :fields="Penalty_fields"
                        :items="results.Penalty"
                      ></b-table>
                    </div>
                  </div>
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.ers_Exceptions") }}
                  </h5>
                  <h6 class="card-header card-header-primary negative blue-grad rounded-0 w-50">
                    {{ $t("message.contragent_search.ers_Exceptions_description") }}
                  </h6>
                  <div class="p-5">
                    <div class="table-responsive">
                      <b-table
                        :fields="Exceptions_fields"
                        :items="results.Exceptions"
                      ></b-table>
                    </div>
                  </div>
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.ers_ShiXinItems") }}
                  </h5>
                  <div class="p-5">
                    <div class="table-responsive">
                      <b-table
                        :fields="ShiXinItems_fields"
                        :items="results.ShiXinItems"
                      ></b-table>
                    </div>
                  </div>
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.ers_ZhiXingItems") }}
                  </h5>
                  <div class="p-5">
                    <div class="table-responsive">
                      <b-table
                        :fields="ZhiXingItems_fields"
                        :items="results.ZhiXingItems"
                      ></b-table>
                    </div>
                  </div>
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.ers_MPledge") }}
                  </h5>
                  <div class="p-5">
                    <div class="table-responsive">
                      <b-table
                        :fields="MPledge_fields"
                        :items="results.MPledge"
                      ></b-table>
                    </div>
                  </div>
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.ers_Pledge") }}
                  </h5>
                  <div class="p-5">
                    <div class="table-responsive">
                      <b-table
                        :fields="Pledge_fields"
                        :items="results.Pledge"
                      ></b-table>
                    </div>
                  </div>
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.ers_SpotCheck") }}
                  </h5>
                  <div class="p-5">
                    <div class="table-responsive">
                      <b-table
                        :fields="SpotCheck_fields"
                        :items="results.SpotCheck"
                      ></b-table>
                    </div>
                  </div>
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{
                      $t("message.contragent_search.ers_CompanyTaxCreditItems")
                    }}
                  </h5>
                  <div class="p-5">
                    <div class="table-responsive">
                      <b-table
                        :fields="CompanyTaxCreditItems_fields"
                        :items="results.CompanyTaxCreditItems"
                      ></b-table>
                    </div>
                  </div>
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.ers_CompanyProducts") }}
                  </h5>
                  <div class="p-5">
                    <div class="table-responsive">
                      <b-table
                        :fields="CompanyProducts_fields"
                        :items="results.CompanyProducts"
                      ></b-table>
                    </div>
                  </div>
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.ers_PermissionEciInfo") }}
                  </h5>
                  <h6>
                    {{ $t("message.contragent_search.ers_PermissionEciInfo_description") }}
                  </h6>
                  <div class="p-5">
                    <div class="table-responsive">
                      <b-table
                        :fields="PermissionEciInfo_fields"
                        :items="results.PermissionEciInfo"
                      ></b-table>
                    </div>
                  </div>
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.ers_PenaltyCreditChina") }}
                  </h5>
                  <div class="p-5">
                    <div class="table-responsive">
                      <b-table
                        :fields="PenaltyCreditChina_fields"
                        :items="results.PenaltyCreditChina"
                      ></b-table>
                    </div>
                  </div>
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.ers_Partners") }}
                  </h5>
                  <div class="p-5">
                    <div class="table-responsive">
                      <b-table
                        :fields="Partners_fields"
                        :items="results.Partners"
                      ></b-table>
                    </div>
                  </div>
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.ers_Employees") }}
                  </h5>
                  <div class="p-5">
                    <div class="table-responsive">
                      <b-table
                        :fields="Employees_fields"
                        :items="results.Employees"
                      ></b-table>
                    </div>
                  </div>
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.ers_Branches") }}
                  </h5>
                  <div class="p-5">
                    <div class="table-responsive">
                      <b-table
                        :fields="Branches_fields"
                        :items="results.Branches"
                      ></b-table>
                    </div>
                  </div>
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.ers_ChangeRecords") }}
                  </h5>
                  <div class="p-5">
                    <div class="table-responsive">
                      <b-table
                        :fields="ChangeRecords_fields"
                        :items="results.ChangeRecords"
                      ></b-table>
                    </div>
                  </div>
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{
                      $t("message.contragent_search.ers_EmergingIndustyList")
                    }}
                  </h5>
                  <div class="p-5">
                    <div class="table-responsive">
                      <b-table
                        :fields="EmergingIndustyList_fields"
                        :items="results.EmergingIndustyList"
                      ></b-table>
                    </div>
                  </div>
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.ers_TagList") }}
                  </h5>
                  <div class="p-5">
                    <div class="table-responsive">
                      <b-table
                        :fields="TagList_fields"
                        :items="results.TagList"
                      ></b-table>
                    </div>
                  </div>
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.ers_ARContactList") }}
                  </h5>
                  <div class="p-5">
                    <div class="table-responsive">
                      <b-table
                        :fields="ARContactList_fields"
                        :items="results.ARContactList"
                      ></b-table>
                    </div>
                  </div>
                  <h5
                    class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                  >
                    {{ $t("message.contragent_search.ers_OriginalName") }}
                  </h5>
                  <div class="p-5">
                    <div class="table-responsive">
                      <b-table
                        :fields="OriginalName_fields"
                        :items="results.OriginalName"
                      ></b-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "enterprise-risk-scan-cn",
  data() {
    return {
      search_complete: false,
      loading: false,
      keyword: "",
      results: {},
      IndustryList: [],
      AreaList: [],

      PermissionInfoList: [],
      PenaltyList: [],
      ExceptionsList: [],
      ShiXinItemsList: [],
      ZhiXingItemsList: [],
      MPledgeList: [],
      PledgeList: [],
      SpotCheckList: [],
      CompanyTaxCreditItemsList: [],
      CompanyProductsList: [],
      PermissionEciInfoList: [],
      PenaltyCreditChinaList: [],
      PartnersList: [],
      EmployeesList: [],
      BranchesList: [],
      ChangeRecordsList: [],
      EmergingIndustyList: [],
      TagList: [],
      ARContactList: [],
      OriginalNameList: [],

      RevokeInfoList: [],
      PermissionInfo_fields: [
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "Province",
          label: this.$t("message.contragent_search.ers_pi_Province"),
        },
        {
          key: "Liandate",
          label: this.$t("message.contragent_search.ers_pi_Liandate"),
        },
        {
          key: "CaseNo",
          label: this.$t("message.contragent_search.ers_pi_CaseNo"),
        },
      ],
      Penalty_fields: [
        {
          key: "DocNo",
          label: this.$t("message.contragent_search.ers_pi_DocNo"),
        },
        {
          key: "PenaltyType",
          label: this.$t("message.contragent_search.ers_pi_PenaltyType"),
        },
        {
          key: "OfficeName",
          label: this.$t("message.contragent_search.ers_pi_OfficeName"),
        },
        {
          key: "Content",
          label: this.$t("message.contragent_search.ers_pi_Content"),
        },
        {
          key: "PenaltyDate",
          label: this.$t("message.contragent_search.ers_pi_PenaltyDate"),
        },
        {
          key: "PublicDate",
          label: this.$t("message.contragent_search.ers_pi_PublicDate"),
        },
        {
          key: "Remark",
          label: this.$t("message.contragent_search.ers_pi_Remark"),
        },
      ],
      Exceptions_fields: [
        {
          key: "AddReason",
          label: this.$t("message.contragent_search.ers_pi_AddReason"),
        },
        {
          key: "AddDate",
          label: this.$t("message.contragent_search.ers_pi_AddDate"),
        },
        {
          key: "RomoveReason",
          label: this.$t("message.contragent_search.ers_pi_RomoveReason"),
        },
        {
          key: "RemoveDate",
          label: this.$t("message.contragent_search.ers_pi_RemoveDate"),
        },
        {
          key: "DecisionOffice",
          label: this.$t("message.contragent_search.ers_pi_DecisionOffice"),
        },
        {
          key: "RemoveDecisionOffice",
          label: this.$t(
            "message.contragent_search.ers_pi_RemoveDecisionOffice",
          ),
        },
      ],
      ShiXinItems_fields: [
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "Liandate",
          label: this.$t("message.contragent_search.ers_pi_Liandate"),
        },
        {
          key: "Anno",
          label: this.$t("message.contragent_search.ers_pi_Anno"),
        },
        {
          key: "Orgno",
          label: this.$t("message.contragent_search.ers_pi_Orgno"),
        },
        {
          key: "Execute",
          label: this.$t("message.contragent_search.ers_pi_Execute"),
        },
        {
          key: "Publicdate",
          label: this.$t("message.contragent_search.ers_pi_Publicdate"),
        },
        {
          key: "Executestatus",
          label: this.$t("message.contragent_search.ers_pi_Executestatus"),
        },
        {
          key: "Actionremark",
          label: this.$t("message.contragent_search.ers_pi_Actionremark"),
        },
        {
          key: "Executegov",
          label: this.$t("message.contragent_search.ers_pi_Executegov"),
        },
      ],
      ZhiXingItems_fields: [
        { key: "Id", label: this.$t("message.contragent_search.ers_pi_Id") },
        {
          key: "Sourceid",
          label: this.$t("message.contragent_search.ers_pi_Sourceid"),
        },
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "Liandate",
          label: this.$t("message.contragent_search.ers_pi_Liandate"),
        },
        {
          key: "Anno",
          label: this.$t("message.contragent_search.ers_pi_Anno"),
        },
        {
          key: "ExecuteGov",
          label: this.$t("message.contragent_search.ers_pi_ExecuteGov"),
        },
        {
          key: "Biaodi",
          label: this.$t("message.contragent_search.ers_pi_Biaodi"),
        },
        {
          key: "Status",
          label: this.$t("message.contragent_search.ers_pi_Status"),
        },
        {
          key: "PartyCardNum",
          label: this.$t("message.contragent_search.ers_pi_PartyCardNum"),
        },
        {
          key: "Updatedate",
          label: this.$t("message.contragent_search.ers_pi_Updatedate"),
        },
      ],
      MPledge_fields: [
        {
          key: "RegisterNo",
          label: this.$t("message.contragent_search.ers_pi_RegisterNo"),
        },
        {
          key: "RegisterDate",
          label: this.$t("message.contragent_search.ers_pi_RegisterDate"),
        },
        {
          key: "PublicDate",
          label: this.$t("message.contragent_search.ers_pi_PublicDate"),
        },
        {
          key: "RegisterOffice",
          label: this.$t("message.contragent_search.ers_pi_RegisterOffice"),
        },
        {
          key: "DebtSecuredAmount",
          label: this.$t("message.contragent_search.ers_pi_DebtSecuredAmount"),
        },
        {
          key: "Status",
          label: this.$t("message.contragent_search.ers_pi_Status"),
        },
      ],
      Pledge_fields: [
        {
          key: "CompanyId",
          label: this.$t("message.contragent_search.ers_pi_CompanyId"),
        },
        {
          key: "RegistNo",
          label: this.$t("message.contragent_search.ers_pi_RegistNo"),
        },
        {
          key: "Pledgor",
          label: this.$t("message.contragent_search.ers_pi_Pledgor"),
        },
        {
          key: "PledgorNo",
          label: this.$t("message.contragent_search.ers_pi_PledgorNo"),
        },
        {
          key: "Pledge",
          label: this.$t("message.contragent_search.ers_pi_Pledge"),
        },
        {
          key: "PledgeNo",
          label: this.$t("message.contragent_search.ers_pi_PledgeNo"),
        },
        {
          key: "PledgedAmount",
          label: this.$t("message.contragent_search.ers_pi_PledgedAmount"),
        },
        {
          key: "RegDate",
          label: this.$t("message.contragent_search.ers_pi_RegDate"),
        },
        {
          key: "PublicDate",
          label: this.$t("message.contragent_search.ers_pi_PublicDate"),
        },
        {
          key: "Status",
          label: this.$t("message.contragent_search.ers_pi_Status"),
        },
      ],
      SpotCheck_fields: [
        { key: "No", label: this.$t("message.contragent_search.ers_pi_No") },
        {
          key: "ExecutiveOrg",
          label: this.$t("message.contragent_search.ers_pi_ExecutiveOrg"),
        },
        {
          key: "Type",
          label: this.$t("message.contragent_search.ers_pi_Type"),
        },
        {
          key: "Date",
          label: this.$t("message.contragent_search.ers_pi_Date"),
        },
        {
          key: "Consequence",
          label: this.$t("message.contragent_search.ers_pi_Consequence"),
        },
        {
          key: "Remark",
          label: this.$t("message.contragent_search.ers_pi_Remark"),
        },
      ],
      CompanyTaxCreditItems_fields: [
        { key: "No", label: this.$t("message.contragent_search.ers_pi_No") },
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "Year",
          label: this.$t("message.contragent_search.ers_pi_Year"),
        },
        {
          key: "Level",
          label: this.$t("message.contragent_search.ers_pi_Level"),
        },
      ],
      CompanyProducts_fields: [
        {
          key: "CompanyName",
          label: this.$t("message.contragent_search.ers_pi_CompanyName"),
        },
        {
          key: "Link",
          label: this.$t("message.contragent_search.ers_pi_Link"),
        },
        {
          key: "ImageUrl",
          label: this.$t("message.contragent_search.ers_pi_ImageUrl"),
        },
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "Domain",
          label: this.$t("message.contragent_search.ers_pi_Domain"),
        },
        {
          key: "Tags",
          label: this.$t("message.contragent_search.ers_pi_Tags"),
        },
        {
          key: "Description",
          label: this.$t("message.contragent_search.ers_pi_Description"),
        },
        {
          key: "Category",
          label: this.$t("message.contragent_search.ers_pi_Category"),
        },
      ],
      PermissionEciInfo_fields: [
        {
          key: "LicensDocNo",
          label: this.$t("message.contragent_search.ers_pi_LicensesDocNo"),
        },
        {
          key: "LicensDocName",
          label: this.$t("message.contragent_search.ers_pi_LicensesDocName"),
        },
        {
          key: "ValidityFrom",
          label: this.$t("message.contragent_search.ers_pi_ValidityFrom"),
        },
        {
          key: "ValidityTo",
          label: this.$t("message.contragent_search.ers_pi_ValidityTo"),
        },
        {
          key: "LicensOffice",
          label: this.$t("message.contragent_search.ers_pi_LicensOffice"),
        },
        {
          key: "LicensContent",
          label: this.$t("message.contragent_search.ers_pi_LicensesContent"),
        },
      ],
      PenaltyCreditChina_fields: [
        {
          key: "CaseNo",
          label: this.$t("message.contragent_search.ers_pi_CaseNo"),
        },
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "Liandate",
          label: this.$t("message.contragent_search.ers_pi_Liandate"),
        },
        {
          key: "Province",
          label: this.$t("message.contragent_search.ers_pi_Province"),
        },
        {
          key: "OwnerName",
          label: this.$t("message.contragent_search.ers_pi_OwnerName"),
        },
        {
          key: "CaseReason",
          label: this.$t("message.contragent_search.ers_pi_CaseReason"),
        },
      ],
      Partners_fields: [
        {
          key: "KeyNo",
          label: this.$t("message.contragent_search.ers_pi_KeyNo"),
        },
        {
          key: "StockName",
          label: this.$t("message.contragent_search.ers_pi_StockName"),
        },
        {
          key: "StockType",
          label: this.$t("message.contragent_search.ers_pi_StockType"),
        },
        {
          key: "StockPercent",
          label: this.$t("message.contragent_search.ers_pi_StockPercent"),
        },
        {
          key: "ShouldCapi",
          label: this.$t("message.contragent_search.ers_pi_ShouldCapi"),
        },
        {
          key: "ShouldDate",
          label: this.$t("message.contragent_search.ers_pi_ShouldDate"),
        },
        {
          key: "InvestType",
          label: this.$t("message.contragent_search.ers_pi_InvestType"),
        },
        {
          key: "InvestName",
          label: this.$t("message.contragent_search.ers_pi_InvestName"),
        },
        {
          key: "RealCapi",
          label: this.$t("message.contragent_search.ers_pi_RealCapi"),
        },
        {
          key: "CapiDate",
          label: this.$t("message.contragent_search.ers_pi_CapiDate"),
        },
        {
          key: "TagsList",
          label: this.$t("message.contragent_search.ers_pi_TagsList"),
        },
        {
          key: "FinalBenefitPercent",
          label: this.$t(
            "message.contragent_search.ers_pi_FinalBenefitPercent",
          ),
        },
        {
          key: "RelatedProduct",
          label: this.$t("message.contragent_search.ers_pi_RelatedProduct"),
        },
        {
          key: "RelatedOrg",
          label: this.$t("message.contragent_search.ers_pi_RelatedOrg"),
        },
      ],
      Employees_fields: [
        {
          key: "KeyNo",
          label: this.$t("message.contragent_search.ers_pi_KeyNo"),
        },
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        { key: "Job", label: this.$t("message.contragent_search.ers_pi_Job") },
      ],
      Branches_fields: [
        {
          key: "CompanyId",
          label: this.$t("message.contragent_search.ers_pi_CompanyId"),
        },
        {
          key: "RegNo",
          label: this.$t("message.contragent_search.ers_pi_RegNo"),
        },
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "BelongOrg",
          label: this.$t("message.contragent_search.ers_pi_BelongOrg"),
        },
        {
          key: "CreditCode",
          label: this.$t("message.contragent_search.ers_pi_CreditCode"),
        },
        {
          key: "OperName",
          label: this.$t("message.contragent_search.ers_pi_OperName"),
        },
      ],
      ChangeRecords_fields: [
        {
          key: "ProjectName",
          label: this.$t("message.contragent_search.ers_pi_ProjectName"),
        },
        {
          key: "BeforeContent",
          label: this.$t("message.contragent_search.ers_pi_BeforeContent"),
        },
        {
          key: "AfterContent",
          label: this.$t("message.contragent_search.ers_pi_AfterContent"),
        },
        {
          key: "ChangeDate",
          label: this.$t("message.contragent_search.ers_pi_ChangeDate"),
        },
      ],
      EmergingIndustyList_fields: [
        {
          key: "IndustryCode",
          label: this.$t("message.contragent_search.ers_pi_IndustryCode"),
        },
        {
          key: "Industry",
          label: this.$t("message.contragent_search.ers_pi_Industry"),
        },
        {
          key: "SubIndustryCode",
          label: this.$t("message.contragent_search.ers_pi_SubIndustryCode"),
        },
        {
          key: "SubIndustry",
          label: this.$t("message.contragent_search.ers_pi_SubIndustry"),
        },
        {
          key: "MiddleCategoryCode",
          label: this.$t("message.contragent_search.ers_pi_MiddleCategoryCode"),
        },
        {
          key: "MiddleCategory",
          label: this.$t("message.contragent_search.ers_pi_MiddleCategory"),
        },
        {
          key: "SmallCategoryCode",
          label: this.$t("message.contragent_search.ers_pi_SmallCategoryCode"),
        },
        {
          key: "SmallCategory",
          label: this.$t("message.contragent_search.ers_pi_SmallCategory"),
        },
      ],
      TagList_fields: [
        {
          key: "Type",
          label: this.$t("message.contragent_search.ers_pi_Type"),
        },
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
      ],
      ARContactList_fields: [
        {
          key: "ContactNo",
          label: this.$t("message.contragent_search.ers_pi_ContactNo"),
        },
        {
          key: "EmailAddress",
          label: this.$t("message.contragent_search.ers_pi_EmailAddress"),
        },
        {
          key: "Address",
          label: this.$t("message.contragent_search.ers_pi_Address"),
        },
      ],
      OriginalName_fields: [
        {
          key: "Name",
          label: this.$t("message.contragent_search.ers_pi_Name"),
        },
        {
          key: "ChangeDate",
          label: this.$t("message.contragent_search.ers_pi_ChangeDate"),
        },
      ],
    };
  },
  methods: {
    /**
     * Gets array of data-fields from the array of Results
     * @param {Array} result – result record for company with list of results
     * @param {String} field - field to get array of
     */
    resultsData(result, field) {
      return result.results.map((result_) => {
        return {
          ...result_[field],
          Year: result_.Year,
          PublishDate: result_.PublishDate,
          No: result_.No,
        };
      });
    },

    translateTextArray(text) {
      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        return axios.post(
          window.base +
            "/library/TranslateNextArray?source=zh&target=" +
            locale,
          text,
        );
      }
    },
    formatStringValues(values, keys) {
      var locale = this.$i18n.locale;

      this.translateTextArray(values).then((res) => {
        res.data.forEach((r, i) => {
          if (locale !== "cn")
            this.results[keys[i]] = JSON.parse(r).translation;
          else this.results[keys[i]] = values[i];
        });
        this.search_complete = true;
      });
    },
    formatObjectTables(object, list) {
      if (object) {
        var keys = Object.keys(object);
        var values = Object.values(object);
        this.translateTextArray(values).then((res) => {
          res.data.forEach((t, i) => {
            list.push({
              Key: keys[i],
              Translated: JSON.parse(t).translation,
              Original: values[i],
            });
          });
        });
      }
    },
    formatArrayObjectTables(object, list) {
      if (object && object.length > 0) {
        object.forEach((obj, i) => {
          var keys = Object.keys(obj);
          var values = Object.values(obj);
          this.translateTextArray(values).then((res) => {
            var translated = {};
            for (let j = 0; j < res.data.length; j++) {
              translated[keys[j]] = JSON.parse(res.data[j]).translation;
            }
            list.push(translated);
          });
        });
      }
    },
    /**
     * Groups results by company RegNo for the output
     * @param {*} results
     */
    groupResults(results) {
      results.forEach((result) => {
        if (
          Object.keys(this.results).indexOf(result.BasicInfoData.RegNo) == -1
        ) {
          //add new company
          this.results[result.BasicInfoData.RegNo] = {
            basic_info: result.BasicInfoData,
            results: [result],
          };
        } else {
          //add result to existing company
          this.results[result.BasicInfoData.RegNo].results.push(result);
        }
      });
    },
    /**
     * Searches for annual reports over API
     */
    searchEnterpriseRiscScan() {
      axios
        .get(window.base + "/admin/GetBillingServiceInfo?code=736")
        .then((response) => {
          this.$bvModal
            .msgBoxConfirm(
              this.$t("message.find_partner.cn_company_info_check_alert") +
                " " +
                response.data.billing_service_price +
                " " +
                response.data.billing_service_cur,
              {
                title: this.$t("message.confirm"),
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: this.$t("message.yes"),
                cancelTitle: this.$t("message.no"),
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true,
              },
            )
            .then((value) => {
              if (value) {
                this.loading = true;
                axios
                  .get(
                    "https://attistrade.cn/library/openAPIRiskScan?keyWord=" +
                      this.keyword,
                  )
                  .then((response) => {
                    if (response.data.Result == null) {
                      this.search_complete = true;
                      this.loading = false;
                      this.no_result = true;
                      return;
                    }
                    this.no_result = false;
                    var locale = this.$i18n.locale;
                    var tmp = Object.entries(response.data.Result);
                    tmp = tmp.filter(
                      (item) =>
                        typeof item[1] !== "object" && !_.isArray(item[1]),
                    );
                    var stringValues = tmp.map((str) => {
                      return str[1];
                    });
                    var stringKeys = tmp.map((str) => {
                      return str[0];
                    });
                    this.formatStringValues(stringValues, stringKeys);
                    if (locale !== "cn") {
                      this.formatObjectTables(
                        response.data.Result.Industy,
                        this.IndustryList,
                      );
                      this.formatObjectTables(
                        response.data.Result.Area,
                        this.AreaList,
                      );
                      this.formatObjectTables(
                        response.data.Result.RevokeInfo,
                        this.RevokeInfoList,
                      );

                      this.formatArrayObjectTables(
                        response.data.Result.Penalty,
                        this.PenaltyList,
                      );
                      this.formatArrayObjectTables(
                        response.data.Result.Exceptions,
                        this.ExceptionsList,
                      );
                      this.formatArrayObjectTables(
                        response.data.Result.ShiXinItems,
                        this.ShiXinItemsList,
                      );
                      this.formatArrayObjectTables(
                        response.data.Result.ZhiXingItems,
                        this.ZhiXingItemsList,
                      );
                      this.formatArrayObjectTables(
                        response.data.Result.MPledge,
                        this.MPledgeList,
                      );
                      this.formatArrayObjectTables(
                        response.data.Result.Pledge,
                        this.PledgeList,
                      );
                      this.formatArrayObjectTables(
                        response.data.Result.SpotCheck,
                        this.SpotCheckList,
                      );
                      this.formatArrayObjectTables(
                        response.data.Result.CompanyTaxCreditItems,
                        this.CompanyTaxCreditItemsList,
                      );
                      this.formatArrayObjectTables(
                        response.data.Result.CompanyProducts,
                        this.CompanyProductsList,
                      );
                      this.formatArrayObjectTables(
                        response.data.Result.PermissionEciInfo,
                        this.PermissionEciInfoList,
                      );
                      this.formatArrayObjectTables(
                        response.data.Result.PenaltyCreditChina,
                        this.PenaltyCreditChinaList,
                      );
                      this.formatArrayObjectTables(
                        response.data.Result.Partners,
                        this.PartnersList,
                      );
                      this.formatArrayObjectTables(
                        response.data.Result.Employees,
                        this.EmployeesList,
                      );
                      this.formatArrayObjectTables(
                        response.data.Result.Branches,
                        this.BranchesList,
                      );
                      this.formatArrayObjectTables(
                        response.data.Result.ChangeRecords,
                        this.ChangeRecordsList,
                      );
                      this.formatArrayObjectTables(
                        response.data.Result.EmergingIndustyList,
                        this.EmergingIndustyList,
                      );
                      this.formatArrayObjectTables(
                        response.data.Result.TagList,
                        this.TagList,
                      );
                      this.formatArrayObjectTables(
                        response.data.Result.ARContactList,
                        this.ARContactList,
                      );
                      this.formatArrayObjectTables(
                        response.data.Result.OriginalNameList,
                        this.OriginalNameList,
                      );
                    } else {
                      this.IndustryList = response.data.Result.Industy;
                      this.AreaList = response.data.Result.Area;
                      this.RevokeInfoList = response.data.Result.RevokeInfo;

                      this.PenaltyList = response.data.Result.Penalty;
                      this.ExceptionsList = response.data.Result.Exceptions;
                      this.ShiXinItemsList = response.data.Result.ShiXinItems;
                      this.ZhiXingItemsList = response.data.Result.ZhiXingItems;
                      this.MPledgeList = response.data.Result.MPledge;
                      this.PledgeList = response.data.Result.Pledge;
                      this.SpotCheckList = response.data.Result.SpotCheck;
                      this.CompanyTaxCreditItemsList =
                        response.data.Result.CompanyTaxCreditItems;
                      this.CompanyProductsList =
                        response.data.Result.CompanyProducts;
                      this.PermissionEciInfoList =
                        response.data.Result.PermissionEciInfo;
                      this.PenaltyCreditChinaList =
                        response.data.Result.PenaltyCreditChina;
                      this.PartnersList = response.data.Result.PartnersList;
                      this.EmployeesList = response.data.Result.Employees;
                      this.BranchesList = response.data.Result.Branches;
                      this.ChangeRecordsList =
                        response.data.Result.ChangeRecordsList;
                      this.EmergingIndustyList =
                        response.data.Result.EmergingIndustyList;
                      this.TagList = response.data.Result.TagList;
                      this.ARContactList = response.data.Result.ARContactList;
                      this.OriginalNameList =
                        response.data.Result.OriginalNameList;
                    }

                    //adding data for pdf
                    this.results.PenaltyList = this.PenaltyList;
                    this.results.ExceptionsList = this.ExceptionsList;
                    this.results.ShiXinItemsList = this.ShiXinItemsList;
                    this.results.ZhiXingItemsList = this.ZhiXingItemsList;
                    this.results.MPledgeList = this.MPledgeList;
                    this.results.PledgeList = this.PledgeList;
                    this.results.SpotCheckList = this.SpotCheckList;
                    this.results.CompanyTaxCreditItemsList =
                      this.CompanyTaxCreditItemsList;
                    this.results.CompanyProductsList = this.CompanyProductsList;
                    this.results.PermissionEciInfoList =
                      this.PermissionEciInfoList;
                    this.results.PenaltyCreditChinaList =
                      this.PenaltyCreditChinaList;
                    this.results.PartnersList = this.PartnersList;
                    this.results.EmployeesList = this.EmployeesList;
                    this.results.BranchesList = this.BranchesList;
                    this.results.ChangeRecordsList = this.ChangeRecordsList;
                    this.results.EmergingIndustyList = this.EmergingIndustyList;
                    this.results.TagList = this.TagList;
                    this.results.ARContactList = this.ARContactList;
                    this.results.OriginalNameList = this.OriginalNameList;
                    this.results.ContactInfo = response.data.Result.ContactInfo;
                    this.results.ImageUrl = response.data.Result.ImageUrl;
                    this.results.RevokeInfoList = this.RevokeInfoList;

                    this.loading = false;
                  })
                  .catch((e) => {
                    console.log("catch", e);
                    this.search_complete = true;
                    this.no_result = true;
                    let response = {
                      data: {
                        Status: "200",
                        Message: "【有效请求】查询成功",
                        OrderNumber: "ECIINFOOVERVIEW2022092815552815237895",
                        Result: {
                          PermissionInfo: [],
                          Penalty: [],
                          Exceptions: [],
                          ShiXinItems: [],
                          ZhiXingItems: [],
                          MPledge: [],
                          Liquidation: null,
                          Pledge: [],
                          SpotCheck: [],
                          CompanyTaxCreditItems: [],
                          CompanyProducts: [],
                          PermissionEciInfo: [
                            {
                              LicensDocNo: "91110102593859063A",
                              LicensDocName: "营业执照",
                              ValidityFrom: "2012-03-21",
                              ValidityTo: "2099-12-31",
                              LicensOffice: "北京市工商行政管理局西城分局",
                              LicensContent: "国家电网公司国际业务服务分公司",
                            },
                            {
                              LicensDocNo: "J1000115254402",
                              LicensDocName: "开户许可",
                              ValidityFrom: "",
                              ValidityTo: "",
                              LicensOffice: "",
                              LicensContent: "变更",
                            },
                            {
                              LicensDocNo: "",
                              LicensDocName: "开户许可",
                              ValidityFrom: "",
                              ValidityTo: "",
                              LicensOffice: "中国人民银行营业管理部",
                              LicensContent: "变更",
                            },
                          ],
                          PenaltyCreditChina: [],
                          Partners: [],
                          Employees: [],
                          Branches: [],
                          ChangeRecords: [
                            {
                              ProjectName: "负责人",
                              BeforeContent: "杜至刚",
                              AfterContent: "朱光超*",
                              ChangeDate: "2015-12-29",
                            },
                            {
                              ProjectName: "经营范围",
                              BeforeContent:
                                "电力方面的技术咨询、服务；货物进出口、技术进出口、代理进出口。",
                              AfterContent:
                                "电力方面的技术咨询、服务；货物进出口、技术进出口、代理进出口。（依法须经批准的项目,经相关部门批准后依批准的内容开展经营活动。）",
                              ChangeDate: "2015-02-04",
                            },
                          ],
                          ContactInfo: {
                            WebSite: null,
                            PhoneNumber: "010-66597593",
                            Email: "lingmiao-jia@sgcc.com.cn",
                          },
                          Industry: {
                            IndustryCode: "M",
                            Industry: "科学研究和技术服务业",
                            SubIndustryCode: "75",
                            SubIndustry: "科技推广和应用服务业",
                            MiddleCategoryCode: "753",
                            MiddleCategory: "科技中介服务",
                            SmallCategoryCode: "7530",
                            SmallCategory: "科技中介服务",
                          },
                          EmergingIndustyList: null,
                          InsuredCount: "42",
                          EnglishName: "State Grid Corporation of China",
                          PersonScope: "少于50人",
                          IXCode: null,
                          TagList: [
                            { Type: "903", Name: "存续" },
                            { Type: "505", Name: "小微企业" },
                          ],
                          ARContactList: [
                            {
                              ContactNo: "66597593",
                              EmailAddress: "lingmiao-jia@sgcc.com.cn",
                              Address: "北京市西城区西长安街86号",
                            },
                          ],
                          EconKindCodeList: ["0"],
                          KeyNo: "c5a99b698215d4aa6685289293509c1f",
                          Name: "国家电网公司国际业务服务分公司",
                          No: "110102014746161",
                          BelongOrg: "北京市西城区市场监督管理局",
                          OperId: "p42646ae9d6fe75e95e70a2f691563bd",
                          OperName: "朱光超",
                          StartDate: "2012-03-21 00:00:00",
                          EndDate: "",
                          Status: "存续（在营、开业、在册）",
                          Province: "BJ",
                          UpdatedDate: "2022-08-29 15:55:26",
                          CreditCode: "91110102593859063A",
                          RegistCapi: "",
                          EconKind: "全民所有制分支机构（非法人）",
                          Address:
                            "北京市西城区六铺炕街5号1号楼613室(德胜园区)",
                          Scope:
                            "电力方面的技术咨询、服务；货物进出口、技术进出口、代理进出口。（依法须经批准的项目，经相关部门批准后依批准的内容开展经营活动。）",
                          TermStart: "2012-03-21 00:00:00",
                          TeamEnd: "",
                          CheckDate: "2015-12-29 00:00:00",
                          OrgNo: "59385906-3",
                          IsOnStock: "0",
                          StockNumber: null,
                          StockType: null,
                          OriginalName: [],
                          ImageUrl:
                            "https://image.qcc.com/logo/c5a99b698215d4aa6685289293509c1f.jpg?x-oss-process=style/logo_120",
                          EntType: "0",
                          RecCap: null,
                          RevokeInfo: null,
                          Area: {
                            Province: "北京市",
                            City: "北京市",
                            County: "西城区",
                          },
                          AreaCode: "110102",
                        },
                      },
                    };
                    this.loading = false;
                    this.results = response.data.Result;
                  });
              }
            });
        });
    },
  },
};
</script>